import { render } from "./ExportArabian.vue?vue&type=template&id=f8bf3cc2&scoped=true"
import script from "./ExportArabian.vue?vue&type=script&lang=js"
export * from "./ExportArabian.vue?vue&type=script&lang=js"

import "./ExportArabian.vue?vue&type=style&index=0&id=f8bf3cc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bf3cc2"]])

export default __exports__